<ejs-dropdownlist
  id="locationField"
  #locationField
  [dataSource]="options"
  [fields]="fields"
  [enableVirtualization]="true"
  [enabled]="!disabled"
  (change)="onLocationChanged($event)"
  cssClass="e-outline"
  [allowFiltering]="true"
  [noRecordsTemplate]="'No Locations Found'"
  [filterType]="'contains'"
  [placeholder]="'General.SelectLocation' | translate"
  >
</ejs-dropdownlist>
<!-- <div *ngIf='loading' class="spinner-overlay">
  <mat-spinner [diameter]="20"></mat-spinner>
</div> -->
